import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("first-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().top < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-33" data-mp="gob19jkkfnfx">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 sm:pb-5" data-id="element-34" data-mp="br2fl907l19x">
          <a href={CHECKOUT_URL} className="animate-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl border-b-4 border-cta-hover bg-cta px-5 py-4 font-display text-base font-extrabold uppercase tracking-wide text-cta-text shadow-[0_10px_30px_rgba(0,0,0,0.45)]" data-id="element-35" data-mp="2b2fgi7b41l70">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="26axerh19jgkz" />
            Get It Now for $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}